module.exports = __webpack_public_path__ + "static/media/noun-copy-5649964-142350.95d3d7ad.svg";